import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonIcon, IonItem, IonLabel, IonList, IonSkeletonText } from '@ionic/react';
import { refreshCircleOutline } from 'ionicons/icons';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../../components/common';
import DashboardBar from '../../components/dashboardBar';
import Layout from '../../components/layout';
import { withTranslation } from '../../lib/translate';
import { checkBackgroundColor, forwardTo, getDefaultRoute, getSingleDeliveryOption, isDefined, isEmptyObject, isWebConfig, openExternalLink, sendToAnalytics } from '../../lib/utils';
import './index.css';
import Basket from '../../lib/basket';
import voucherIcon from '../../assets/images/voucher.svg'
import { getMyEventsCurrent, getRewards, loading, setCommonProp } from '../../store/actions';
import Slider, { Slide } from '../../components/slider';
import { ReactComponent as Repeat } from '../../assets/images/reorder.svg';
import { informationCircleOutline, ticketOutline } from 'ionicons/icons';
import Modal from '../../components/modal';
import moment from '../../lib/moment';
import { ReactComponent as MailIcon } from '../../assets/images/mail.svg';
import DashboardRewards from '../../components/dashboardRewards';
import api from '../../lib/api';
import Loading from '../../components/spinner';
import { LoyaltyStatusBanner } from '../loyaltyStatus';

class Dashboard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			singleDelivery: null,
			image: '',
			dashboardWithTiles: !!getConfig().general.dashboardWithTiles,
			backgorundColor: false,
			newsModalOpened: false,
			selectedNews: null,
			topItems: [],
			newsLoaded: false,
			topItemsLoaded: !getConfig().flags.hasTopItemsOnDashboard,
			contentReady: false
		};
	}

	componentDidUpdate() {
		if (!this.state.contentReady && this.state.newsLoaded && this.state.topItemsLoaded) {
			this.setState({ contentReady: true });
		}
	}
	calculateHeaderHeight = () => {
		const orders = this.props.orderHistory.length;
		const vouchers = this.props.vouchers.length;
		let size = 0;
		if (this.props.loggedIn) {
			if (vouchers > 0) {
				size = size + 60;
			}
			if (orders > 0) {
				size = size + 60;
			}
		}

		return size;
	};

	async componentDidMount() {
		if (!this.props.auth.loggedIn && getConfig().flags.hasRegisterOnLoyaltyPage) {
			forwardTo('/loyalty')
		} else {
			if (getConfig().flags.hasRewardsOnDashboard && this.props.auth.loggedIn) {
				this.props.dispatch(getRewards());

			}

			api.getNews()
				.then((news) => this.props.dispatch(setCommonProp('news', Array.isArray(news) ? news : [])))
				.catch(() => { })
				.finally(() => this.setState({ newsLoaded: true }));

			if (this.props.auth.loggedIn) {
				this.props.dispatch(getMyEventsCurrent(1));
			}

			if (getConfig().flags.hasTopItemsOnDashboard) {
				try {
					this.props.dispatch(loading(true))
					const menuId = Basket?.getMenu();
					const businessLocationId = Basket.getRestaurant()?.business_location_id;
					const payload = {};
					if (businessLocationId) {
						payload.business_location_id = businessLocationId;
						if (menuId) {
							payload.menu_id = menuId;
						}
					}
					const items = await api.getTopProducts(payload);
					this.setState({ topItems: Array.isArray(items) ? items.map(el => el.items) : [], topItemsLoaded: true }, () => {
						this.props.dispatch(loading(false))

					})
				} catch (err) {

					this.setState({ topItems: [], topItemsLoaded: true }, () => {
						this.props.dispatch(loading(false))

					})

				}

			}

			if (isWebConfig()) {
				const defaultRoute = getDefaultRoute(this.props.navConfig);
				forwardTo(defaultRoute.path);
			}

			try {
				sendToAnalytics('page_view', {
					page_title: 'Home',
					page_location: typeof window !== 'undefined' ? window.location?.href : '',
					page_path: '/dashboard',
				});
			} catch (e) { console.log('Error_sending_page_view_analytics', e); }

			if (getConfig().general.dashboardWithTiles) {
				this.setState({ dashboardWithTiles: true });
			}
			getSingleDeliveryOption().then((res) => {
				this.setState({
					singleDelivery: res,
					image: this.props.clientProfile?.main_image || "",
				});
			});
		}

	}

	filterNews = (news) => {
		const now = moment.tz(getConfig().timezone);

		return news.filter(item => {
			const display_times = item.additional_config?.display_times;

			if (!Array.isArray(display_times) || display_times.length === 0) {
				return true;
			}
			return display_times.some(({ from, to }) => {
				const fromTime = moment.unix(Number(from)).tz(getConfig().timezone);
				const toTime = moment.unix(Number(to)).tz(getConfig().timezone);
				return now.isBetween(fromTime, toTime, null, '[]');
			});
		});
	}
	getTodayEventSubtitle = (event) => {
		const { __ } = this.props;
		const parts = [
			event.name,
			event.start_time ? `${moment(event.start_time).format('h:mma')}` : null,
		].filter(Boolean);
		return parts.join(' · ');
	}

	render() {
		const { __, screenName, orderHistory, vouchers, news, profile, rewards, clientProfile, myEventsCurrent } = this.props;
		const todayEvents = myEventsCurrent || [];
		const { singleDelivery, image, topItems } = this.state;
		const dashboardContent = getConfig().dashboardConfig;
		const filteredNews = this.filterNews(news)
		filteredNews.sort((a, b) => (a?.sort_order ?? 0) - (b?.sort_order ?? 0))

		return (
			<Loading transparent>
				<Layout
					color="transparent"
					noPadding={true}
				>
					{!this.state.contentReady && !this.state.dashboardWithTiles && (
						<>
							<div className="absolute-content dash-layout"></div>
							<IonCard className="dash-card dash-skeleton">
								<IonCardHeader className="ion-text-center">
									<IonSkeletonText animated className="dash-skeleton-label" />
									<IonSkeletonText animated className="dash-skeleton-title" />
								</IonCardHeader>
								<IonCardContent className="dash-menu">
									{[0, 1, 2].map((i) => (
										<IonSkeletonText key={i} animated className="dash-skeleton-item" />
									))}
								</IonCardContent>
							</IonCard>
						</>
					)}
					{!this.state.contentReady && this.state.dashboardWithTiles && (
						<div className="dashboard-skeleton">
							<IonSkeletonText animated className="dashboard-skeleton-banner" />
							<div className="dashboard-header">
								<IonSkeletonText animated className="dashboard-skeleton-subtitle" />
								<IonSkeletonText animated className="dashboard-skeleton-title" />
								<IonSkeletonText animated className="dashboard-skeleton-line" />
								<IonSkeletonText animated className="dashboard-skeleton-line short" />
							</div>
							<div className="dashboard-cards-wrapper">
								{[0, 1, 2].map((i) => (
									<IonSkeletonText key={i} animated className="dashboard-skeleton-card" />
								))}
							</div>
						</div>
					)}
					{this.state.contentReady && (!this.state.dashboardWithTiles ? (
						<>
							<div className="absolute-content dash-layout" style={{ backgroundImage: `url(${image})` }}></div>
							<IonCard className="dash-card">
								<IonCardHeader className="ion-text-center">
									<IonLabel color="dark">{__('Welcome Back')}</IonLabel>
									<IonCardTitle>{screenName}</IonCardTitle>
								</IonCardHeader>
								<IonCardContent className="dash-menu">
									<IonList>
										{getConfig().delivery.filter((d) => !d.isRemoved && !d.isDisabled).length > 0 && (
											<>
												{getConfig().flags.hasOrdering ? (
													singleDelivery ? (
														<IonItem className="clickable" onClick={() => forwardTo('/click-and-collect')}>
															<div tabIndex="-1"></div>
															<IonLabel>{__(singleDelivery?.label)}</IonLabel>
														</IonItem>
													) : (
														<IonItem className="clickable" onClick={() => forwardTo('/delivery-options')}>
															<div tabIndex="-1"></div>
															<IonLabel>{__('Start New Order')}</IonLabel>
														</IonItem>
													)
												) : null}
											</>
										)}
										{getConfig().flags.hasLoyalty && (
											<IonItem className="clickable" onClick={() => forwardTo('/loyalty')}>
												<div tabIndex="-1"></div>
												<IonLabel>{__('Loyalty')}</IonLabel>
											</IonItem>
										)}

										<IonItem lines="none" className="clickable" onClick={() => forwardTo('/account')}>
											<div tabIndex="-1"></div>
											<IonLabel>{__('My Account')}</IonLabel>
										</IonItem>
									</IonList>
								</IonCardContent>
							</IonCard>
						</>
					) : (
						<>
							{filteredNews.length > 0 &&
								<>
									<Slider
										settings={{
											slidesPerView: 1.1,
											centeredSlides: true,
											spaceBetween: 10,
											initialSlide: 0,
											autoplay: {
												disableOnInteraction: false,
											},
											pagination: {
												el: '.dashboard-news-pagination',
												clickable: true,
											},
											loop: filteredNews.length >= 5,
										}}
									>
										{filteredNews.map((item, i) => (
											<Slide onClick={() => {
												if (item.content?.trim() !== '') {
													this.setState({
														selectedNews: { title: item.title, content: item.content },
														newsModalOpened: true
													})
												} else {
													const path = item?.path
													if (path && path !== '') {
														path.startsWith("http") ? openExternalLink(path) : forwardTo(path);
													}
												}

											}}
												className={`slide-${i}`} key={i}><img src={item.banner_image} /></Slide>
										))}
										<div className="swiper-pagination dashboard-news-pagination"></div>
									</Slider>
									{this.state.newsModalOpened &&
										<Modal
											isOpen={this.state.newsModalOpened}
											onDidDismiss={() => this.setState({ newsModalOpened: false, selectedNews: null })}>

											<div className="lefted">
												<Title className='modal-title'>{this.state.selectedNews?.title}</Title>
												<div dangerouslySetInnerHTML={{ __html: this.state.selectedNews?.content }}></div>
											</div>
										</Modal>
									}

								</>
							}
							<Spacer size={5} />
							{this.props.loggedIn && (
								<>
									<div className="dashboard-bars-wrapper">
										{todayEvents.map((event, index) => (
											<DashboardBar className='dashboard-event-bar' key={`today-event-${event.id != null ? event.id : index}`} handleClick={() => forwardTo('/ticket', { eventId: event.id, eventName: event.name })}>
												<IonIcon className='dashboard-bar-icon' size="medium" icon={ticketOutline}></IonIcon>
												<div>
													<StrongText className="block">{__('You have an event tonight')}</StrongText>
													<SmallText className="block">{this.getTodayEventSubtitle(event)}</SmallText>
												</div>
											</DashboardBar>
										))}
										{this.props.notifications.filter(el => !el.is_read).length > 0 &&
											<DashboardBar handleClick={() => forwardTo('/inbox')}>
												<MailIcon />
												<NormalText>{__('You have new message')}</NormalText>
											</DashboardBar>
										}

										{vouchers.length > 0 && (
											<>
												<DashboardBar
													handleClick={() => {
														if (vouchers[0].is_game && !isEmptyObject(vouchers[0].reward.game_config)) {
															forwardTo('/spin-and-win', {
																voucher: vouchers[0],

															})
														} else {
															forwardTo('/voucher', {
																voucher: vouchers[0],

															})
														}
													}

													}
												>
													{vouchers[0]?.additional_config?.voucher_icon ?
														<img src={vouchers[0]?.additional_config?.voucher_icon} />

														:
														<img src={voucherIcon} />

													}
													<NormalText>{`${__('New voucher')}: ${__(vouchers[0].reward.name)}`}</NormalText>
												</DashboardBar>
											</>
										)}
										{!Basket.has_multi_basket && getConfig().flags.hasOrdering &&
											<>
												{orderHistory.filter((order) => !order.is_gift && !order.is_event && order.status.toUpperCase() !== 'NEW' && order.status.toUpperCase() !== 'CREATED').length > 0 && (
													<DashboardBar handleClick={() => forwardTo('./history', { tab: 'order' })}>
														<Repeat />
														<NormalText>{__('Reorder a previous order')}</NormalText>
													</DashboardBar>
												)}
											</>
										}
										{orderHistory.filter((order) => order.show_banner).length > 0 && orderHistory.filter((order) => !order.is_gift && !order.is_event).length > 0 && Basket.has_multi_basket && (
											<>
												{orderHistory
													.filter((order) => order.show_banner)
													.map((orderInstance, index) => (
														<DashboardBar key={`order-history_${index}`} handleClick={() => forwardTo('./history-details', { tab: 'order', order: orderInstance })}>
															<IonIcon className='dashboard-bar-icon' size="medium" icon={informationCircleOutline}></IonIcon>
															<NormalText>{`${__('View order status')} #${orderInstance.id}`}</NormalText>
														</DashboardBar>
													))}
											</>
										)}
									</div>

								</>

							)}
							<div className={`dashboard-content`}>

								<div
									className="dashboard-header"							>
									<Subtitle className="uppercase bold letter-spacing-big">{__(dashboardContent?.title)}</Subtitle>
									<Title className='page-title-centered'>
										{`${__('Welcome')}${screenName ? ` ${screenName}` : ''}`}
									</Title>
									{(dashboardContent?.description && dashboardContent?.description.replace(/<br\s*\/?>/gi, '\n') !== '') &&
										<>
											<Spacer size={2} />
											<NormalText style={{ whiteSpace: 'pre-line' }}>{__(dashboardContent?.description).replace(/<br\s*\/?>/gi, '\n')}</NormalText>

										</>
									}
									{this.props.auth.loggedIn && getConfig().flags.hasLoyaltyTiers &&
										<div className='dashboard-loyalty-status-wrapper'>
											<LoyaltyStatusBanner />
										</div>
									}
									{this.props.auth.loggedIn && rewards.length > 0 && getConfig().flags.hasRewardsOnDashboard &&
										<div className='dashboard-rewards-wrapper'>
											{getConfig().flags.hasMilestoneRewards &&
												<DashboardRewards milestoneRewards={true} available_points={profile.milestone_balance} rewards={rewards} __={__} />

											}
											{getConfig().flags.hasUnlockRewards &&
												<DashboardRewards unlockRewards={true} available_points={profile.available_balance} rewards={rewards} __={__} />
											}
										</div>
									}
									{topItems.length > 0 &&
										<div className='top-items-wrapper'>
											<Subtitle>{__('Top selling items')}</Subtitle>
											<Spacer size={2} />
											<Slider
												settings={{
													slidesPerView: (document.querySelector('.dashboard-header')?.clientWidth || 400) / 150,
													spaceBetween: 10,
													initialSlide: 0,
													pagination: {
														el: '.top-items-pagination',
														clickable: true,
													},
												}}
											>
												{topItems.flat().map((product, i) => (
													<Slide
														key={i}
														onClick={() => forwardTo('/item-details', { ...product, fromDashboard: true })}
													>
														<div className='top-items-card'>
															<img
																src={product.itemRichData?.squareImageUrl?.replace(/http:\/\//g, 'https://') || clientProfile?.logo_image}
																className='top-items-card-image'
															/>
															<StrongText className='top-item-name'>{__(Basket.getProductName(product, profile))}</StrongText>
															<SmallText>{Basket.formatPrice(Basket.getProductCardPrice(product), true)}</SmallText>
														</div>
													</Slide>
												))}
												<div className="swiper-pagination top-items-pagination"></div>
											</Slider>
										</div>
									}

								</div>
								<div className="dashboard-cards-wrapper" style={{ ...(getConfig().frenchDisclaimer?.dashboardDisclaimerImage ? { paddingBottom: '50px' } : null) }}>
									{dashboardContent?.data.map((item, i) => {
										return (
											<div key={i} className="dashboard-card " onClick={() =>
												item.path.startsWith("http") ? openExternalLink(item.path) : forwardTo(item.path)

											}>
												<img src={item.image} />
												<Title style={{ textAlign: 'center' }} key={i}>{__(item.title)}</Title>
											</div>
										);
									})}
								</div>
							</div>
						</>
					))}
					{this.state.contentReady && getConfig().frenchDisclaimer?.dashboardDisclaimerImage && (
						<div className="dashboard-disclaimer-wrapper">
							<img src={getConfig().frenchDisclaimer?.dashboardDisclaimerImage}></img>
						</div>
					)}
				</Layout>
			</Loading>
		);
	}
}

const stateToProps = (state) => {
	const { profile, vouchers, auth, notifications } = state.profile;
	const { clientProfile, clientStyles, navConfig, news } = state.common;
	const { orderHistory, myEventsCurrent } = state.orders;
	const { rewards } = state.restaurants;

	let screenName = '';
	if (isDefined(profile) && !isEmptyObject(profile) && profile.first_name) {
		screenName = profile.first_name;
	}
	return {
		loggedIn: auth.loggedIn,
		screenName,
		clientProfile,
		clientStyles,
		orderHistory: orderHistory || [],
		myEventsCurrent: myEventsCurrent || [],
		vouchers: vouchers || [],
		navConfig,
		news,
		auth,
		notifications: notifications || [],
		profile,
		rewards: rewards || [],
	};
};

export default connect(stateToProps)(withTranslation(Dashboard));
